import React, { PropTypes } from 'react';
import classnames from 'classnames';

import Link from 'components/Link';
import './style.scss';

const InfoBar = (props) => {

  const {
    isStatic,
    onClose,
    type
  } = props;

  const className = classnames(
    'InfoBar',
    {
      'is-static': isStatic
    }
  );

  const classNameCallout = classnames(
    'callout',
    {
      [`${type}`]: !!type
    }
  );

  const classNameClose = classnames(
    'search-close',
    {
      ['is-hidden']: !onClose
    }
  );

  const handleLinkClick = (event) => {
    event.preventDefault();
    props.onClose();
  };

  return (
    <div className={className}>
      <div className={classNameCallout}>
        <Link to="/" iconName={classNameClose} onClick={handleLinkClick}>Close</Link>

        <div className="wrapper-small">
          {props.title && <h4>{props.title}</h4>}
          <p>{props.message}</p>
        </div>
      </div>
    </div>
  );
};

InfoBar.propTypes = {
  isStatic: PropTypes.bool,
  type: PropTypes.string,
  title: PropTypes.string,
  message: PropTypes.string,
  onClose: PropTypes.func
};

export default InfoBar;



/** WEBPACK FOOTER **
 ** ./src/members/Main/__shared__/components/InfoBar/index.js
 **/